import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

interface MobileMenuProps {
  onClose: () => void;
}

const MobileMenu: React.FC<MobileMenuProps> = ({ onClose }) => {
  const location = useLocation();
  const { isAuthenticated, isLoading, loginWithRedirect, logout } = useAuth0();
  
  const menuItems = [
    { path: "/", label: "Home", icon: "🏠", protected: false },
    { path: "/leaderboard", label: "Leaderboard", icon: "🏆", protected: false },
    { path: "/ranks", label: "Ranks", icon: "👑", protected: false },
    // TODO: Re-enable Favorites when API is implemented
    // { path: "/favorites", label: "Favorites", icon: "❤️", protected: true },
    { path: "/profile", label: "Profile", icon: "👤", protected: true },
    { path: "/about", label: "About", icon: "ℹ️", protected: false }
  ];
  
  const visibleMenuItems = menuItems.filter(item => !item.protected || isAuthenticated);
  
  return (
    <div className="mobile-menu">
      <div className="mobile-menu-bg"></div>
      
      <div className="mobile-menu-content">
        <ul className="mobile-menu-list">
          {visibleMenuItems.map((item, index) => (
            <li key={index} className="mobile-menu-item">
              <Link 
                to={item.path} 
                className={`mobile-menu-link ${location.pathname === item.path ? 'active' : ''}`}
                onClick={onClose}
              >
                <span className="menu-item-icon">{item.icon}</span>
                <span className="menu-item-text">{item.label}</span>
                {location.pathname === item.path && (
                  <span className="menu-item-active-indicator"></span>
                )}
              </Link>
            </li>
          ))}
          
          {!isLoading && (
            <li className="mobile-menu-item">
              {isAuthenticated ? (
                <button 
                  onClick={() => {
                    logout({ logoutParams: { returnTo: window.location.origin } });
                    onClose();
                  }}
                  className="mobile-menu-link auth-button"
                >
                  <span className="menu-item-icon">🚪</span>
                  <span className="menu-item-text">Logout</span>
                </button>
              ) : (
                <button 
                  onClick={() => {
                    loginWithRedirect();
                    onClose();
                  }}
                  className="mobile-menu-link auth-button"
                >
                  <span className="menu-item-icon">🔐</span>
                  <span className="menu-item-text">Login</span>
                </button>
              )}
            </li>
          )}
        </ul>
        
        <div className="mobile-menu-footer">
          <p className="menu-version">KNOW Bible Trivia v1.0</p>
          <button className="menu-close-button" onClick={onClose}>
            Close Menu
          </button>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;